// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Sso resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class SsoClient {
  constructor(private readonly http: HttpClient) {}

  /** Create Sso Provider via the Inferrex API. */
  async createSsoProvider(request: { providerId: string; displayName: string; type: string; redirectUri: string; groupsClaim?: string; idpEntityId?: string; ssoUrl?: string; certificate?: string; spEntityId?: string; audience?: string; spPrivateKey?: string; clientId?: string; issuer?: string; clientSecret?: string; scopes?: string }, requestOptions?: RequestOptions): Promise<{ provider: Record<string, unknown>; sovereignMode: boolean }> {
    return this.http.post<{ provider: Record<string, unknown>; sovereignMode: boolean }>('/v1/workspace/sso/providers', request, requestOptions);
  }

  /** List Sso Providers via the Inferrex API. */
  async listSsoProviders(): Promise<{ providers: Record<string, unknown>[]; maxProviders: number; deploymentMode: string; sovereignMode: boolean }> {
    return this.http.get<{ providers: Record<string, unknown>[]; maxProviders: number; deploymentMode: string; sovereignMode: boolean }>('/v1/workspace/sso/providers');
  }

  /** Delete Sso Provider via the Inferrex API. */
  async deleteSsoProvider(providerId: string, requestOptions?: RequestOptions): Promise<{ deleted: boolean }> {
    return this.http.request<{ deleted: boolean }>('DELETE', `/v1/workspace/sso/providers/${providerId}`, undefined, undefined, requestOptions);
  }

  /** Update Sso Role Mapping via the Inferrex API. */
  async updateSsoRoleMapping(request: { mappings: Record<string, unknown>[] }, requestOptions?: RequestOptions): Promise<{ mappings: Record<string, unknown>[]; updatedAt: string }> {
    return this.http.request<{ mappings: Record<string, unknown>[]; updatedAt: string }>('PUT', '/v1/workspace/sso/role-mapping', request, undefined, requestOptions);
  }

  /** Get Sso Role Mapping via the Inferrex API. */
  async getSsoRoleMapping(): Promise<{ mappings: Record<string, unknown>[]; maxEntries: number }> {
    return this.http.get<{ mappings: Record<string, unknown>[]; maxEntries: number }>('/v1/workspace/sso/role-mapping');
  }
}
